import { COVERGO_SAAS_PROD } from "../consts.js"

export const aiaTh = {
	// CoverStudio PROD
	"aiath-uat-studio.quote.hk": { appConfig: { tenantId: "aiaTh_uat", appId: "covergo_crm" }, envConfig: COVERGO_SAAS_PROD }
}
